<template>
  <div class="main-body">
    <div class="header">用药组</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right: 5px;">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 5px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-button size="mini" type="primary" plain @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>

      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;">

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="药品：">
                <el-tag v-for="(value,i) in props.row.listMedicationItem" :key="i" >{{value.name}}</el-tag>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
        <el-table-column prop="name" label="用药组名称"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="timeSpan(scope.row.createTime)<4" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-bind:zoneValue="zoneValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:zoneValue="zoneValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>


import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

import Add from "./Add";
import Edit from "./Edit";
import Elderly from "@/views/Elderly/Comm/ElderlyInsCheckIn2";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalAdd:false,
      showModalEdit:false,

      showModalGetElderly:false,


      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

      userCode: "",
      userName:'',
      elderlyCode:'',

      type:2,

    }
  },
  components:{
    Add,Edit,Elderly
  },
  created(){
    this.getIns();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListByGovCode2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },



    timeSpan(time){
      var d1 = new Date('2016/03/28 10:17:22');

      d1 = new Date(timefilters(time));
      var d2 = new Date();

      //console.log(parseInt(d2 - d1));//两个时间相差的毫秒数
      //console.log(parseInt(d2 - d1) / 1000);//两个时间相差的秒数
      //console.log(parseInt(d2 - d1) / 1000 / 60);//两个时间相差的分钟数
      //console.log(parseInt(d2 - d1) / 1000 / 60);//两个时间相差的小时数

      return parseInt(d2 - d1) / 1000 / 60/60;

    },



    formatterTime(row, column, cellValue) {
      return timefilters(cellValue)
    },



    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.type);
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    handleEdit(index,row){
      this.showModalEdit = !this.showModalEdit;
      this.$refs.myEdit.init(row);
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type);
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
      this.elderlyCode = row.elderlyCode;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
      this.elderlyCode = '';
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationGroup/GovPage2",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          institutionCode: this.institutionCode,
          elderlyCode:this.elderlyCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },




  }
}
</script>

<style scoped>

</style>
